export default __webpack_public_path__ + "static/media/videocard.d2bda960.png";